import { useReducer } from "react";
import { ModalActionType } from "../ModalProvider.types";

var modalIsActive = function modalIsActive(state, name) {
  return state.some(function (Modal) {
    return Modal.props.name === name;
  });
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ModalActionType.SHOW_MODAL:
      return modalIsActive(state, action.payload.props.name) ? state : state.concat(action.payload);

    case ModalActionType.HIDE_MODAL:
      return state.map(function (Modal) {
        if (Modal.props.name === action.payload) Modal.props.open = false;
        return Modal;
      });

    case ModalActionType.REMOVE_MODAL:
      return state.filter(function (Modal) {
        return Modal.props.name !== action.payload;
      });

    default:
      return state;
  }
};

export function useModalReducer() {
  return useReducer(reducer, []);
}